import React, { useEffect } from 'react';
import { Play, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

interface HomeJourneySectionProps {
  onStartJourney?: () => void;
}

const HomeJourneySection = ({ onStartJourney }: HomeJourneySectionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Garante que a página role para o topo quando o componente for montado ou quando a rota mudar
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const handleStartJourney = () => {
    // Primeiro, força o scroll para o topo
    window.scrollTo(0, 0);
    
    // Pequeno delay para garantir que o scroll aconteceu
    setTimeout(() => {
      // Depois navega para a página
      if (onStartJourney) {
        onStartJourney();
      } else {
        navigate('/caminhada', { replace: true });
      }
    }, 50);
  };

  return (
    <div className="w-full">
      <div className="section-container">
        <div className="category-section w-full max-w-3xl mx-auto">
          <div className="flex justify-center mb-4">
            <img
              src="/logosemfundo.png"
              alt="Logo Bíblia em Louvor"
              className="w-32 h-32 object-contain"
            />
          </div>
          
          <h2 className="section-title">Jornada Bíblica em 9 Etapas</h2>
          <p className="section-description">
            Uma jornada musical através da história bíblica, desde a Criação até o Apocalipse. 
            Cada etapa representa um período importante da narrativa bíblica.
          </p>
          
          <div className="flex flex-col items-center text-center">
            <Button 
              onClick={handleStartJourney} 
              className="w-full py-4 px-6 rounded-xl font-bold text-lg flex items-center justify-center gap-3 bg-gradient-to-r from-amber-400 to-yellow-200 border-2 border-amber-400 shadow-md text-[#23405a] hover:from-amber-500 hover:to-yellow-300 hover:shadow-lg transition-all duration-300 min-w-[44px] min-h-[44px] touch-manipulation"
            >
              <BookOpen className="h-5 w-5 text-amber-700 drop-shadow" />
              <span>Jornada</span>
              <Play className="h-5 w-5 text-amber-700 drop-shadow" />
            </Button>
            
            <p className="text-muted-foreground mt-4">
              9 etapas • 198 músicas • Do Gênesis ao Apocalipse
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeJourneySection;
